// Mirror of supabase/functions/_shared/timezone.ts for the React app.
// Use these helpers anywhere a date/time is shown to users so the studio's
// Eastern timezone is the source of truth — not the visitor's browser.
export const BUSINESS_TZ = "America/New_York" as const;

export const fmtBusinessDate = (
  d: Date | string,
  opts: Intl.DateTimeFormatOptions = {},
) => {
  const date = typeof d === "string" ? parseBusinessDateOnly(d) : d;
  return date.toLocaleDateString("en-US", { timeZone: BUSINESS_TZ, ...opts });
};

export const fmtBusinessTime = (
  d: Date,
  opts: Intl.DateTimeFormatOptions = {},
) => d.toLocaleTimeString("en-US", { timeZone: BUSINESS_TZ, ...opts });

/** Full timestamp (date + time) in the business timezone, e.g. "Sep 2, 2026, 5:00 PM". */
export const fmtBusinessDateTime = (d: Date | string) =>
  new Date(d).toLocaleString("en-US", {
    timeZone: BUSINESS_TZ,
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });


/**
 * Parse a YYYY-MM-DD value as a local-noon Date so that downstream
 * formatting (or react-day-picker comparisons) doesn't slip a day
 * for users west of UTC.
 */
export function parseBusinessDateOnly(dateStr: string): Date {
  // T12:00:00 (no Z) → interpreted as local; noon is safely inside the
  // same calendar day regardless of timezone offset (±14h max).
  return new Date(`${dateStr}T12:00:00`);
}

/** Today as YYYY-MM-DD in the business timezone. */
export function todayInBusinessTZ(now: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: BUSINESS_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? "";
  return `${get("year")}-${get("month")}-${get("day")}`;
}
